import React from 'react';

import { PrismicRichText } from '@prismicio/react';
import { H2 } from '@repo/ui/components/Typography';

import { Text } from './styles';
import { SectionTitleAndTextProps } from './types';

/**
 * utility component for landing pages
 * displays a title and text of a section
 */
const SectionTitleAndText: React.FC<SectionTitleAndTextProps> = ({
  title: _title,
  text: _text,
  slice,
}) => {
  const title = _title || slice?.primary.title;
  const text = _text || slice?.primary.text;

  return (
    <>
      {title && <H2 style={{ textAlign: 'center' }}>{title}</H2>}
      {text && (
        <Text as="div" hasTitle={!!title}>
          <PrismicRichText field={text} />
        </Text>
      )}
    </>
  );
};

export default SectionTitleAndText;
